import { useState, useEffect } from 'react';

// Custom hook for responsive design breakpoints
export function useResponsive() {
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    const [breakpoint, setBreakpoint] = useState('desktop');

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;
            
            setScreenSize({ width, height });
            
            // Set breakpoints
            if (width < 768) {
                setBreakpoint('mobile');
            } else if (width < 1024) {
                setBreakpoint('tablet');
            } else {
                setBreakpoint('desktop');
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial call

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return {
        screenSize,
        breakpoint,
        isMobile: breakpoint === 'mobile',
        isTablet: breakpoint === 'tablet',
        isDesktop: breakpoint === 'desktop'
    };
}

// Custom hook for mobile-first responsive design
export function useMobileFirst() {
    const { breakpoint } = useResponsive();
    
    return {
        showMobileLayout: breakpoint === 'mobile',
        showTabletLayout: breakpoint === 'tablet',
        showDesktopLayout: breakpoint === 'desktop',
        getCurrentBreakpoint: () => breakpoint
    };
}